import { render } from "./recently-viewed-products.vue?vue&type=template&id=45a657a3"
import script from "./recently-viewed-products.vue?vue&type=script&lang=js"
export * from "./recently-viewed-products.vue?vue&type=script&lang=js"

import "./recently-viewed-products.vue?vue&type=style&index=0&id=45a657a3&lang=scss"

import exportComponent from "/Users/connoringold/Documents/projects/bao/toteme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__